export enum ManageTableDataMode {
  Allocation = 'allocation',
  Performance = 'performance',
  Spending = 'spending'
}
